module.exports = __webpack_public_path__ + "static/media/peaks.753f96ba.png";